import { Injectable } from '@angular/core';
import { ktsKey } from '../projects/kts/service/message.service';
var MessageService = /** @class */ (function () {
    function MessageService() {
        this.metaMessages = {};
        this.messages = {};
    }
    MessageService.prototype.setMetaMessages = function (messages) {
        this.metaMessages = messages;
    };
    MessageService.prototype.getMetaMessages = function () {
        return this.metaMessages;
    };
    MessageService.prototype.setMessage = function (messages) {
        var msg = {};
        var keys = this.getKeys();
        for (var i = 0; i < keys.length; i++) {
            msg[keys[i]] = '{ ' + keys[i] + ' }'; // not found message
        }
        this.messages = Object.assign({}, msg, messages);
    };
    MessageService.prototype.getMessage = function () {
        return this.messages;
    };
    MessageService.prototype.replaceMessage = function (msg, pattern, val) {
        var reg = new RegExp("{{" + pattern + "}}", 'g');
        return msg.replace(reg, val);
    };
    MessageService.prototype.getKeys = function () {
        return key.concat(ktsKey);
    };
    MessageService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MessageService.ctorParameters = function () { return []; };
    return MessageService;
}());
export { MessageService };
var key = [
    'LoginComponent.error',
    'LoginComponent.label.email',
    'LoginComponent.label.password',
    'LoginComponent.error.email',
    'LoginComponent.error.password',
    'LoginComponent.button.login',
    'LoginComponent.button.reissuePassword',
    'LoginComponent.note.reissue',
    'LoginComponent.note.heading',
    'LoginComponent.note',
    'PasswordComponent.label.currentPassword',
    'PasswordComponent.label.newPassword',
    'PasswordComponent.label.confirmPassword',
    'PasswordComponent.error.currentPassword',
    'PasswordComponent.error.newPassword',
    'PasswordComponent.error.confirmPassword',
    'PasswordComponent.error.notMatch',
    'PasswordComponent.button.changePassword',
    'PasswordComponent.note',
    'AuComponent.logout.link',
    'AuComponent.button.editmessages',
    'FooterComponent.label.copyright',
    'ListComponent.label.result1',
    'ListComponent.label.result2',
    'ListComponent.label.total1',
    'ListComponent.label.total2',
    'ListComponent.label.rows',
    'ListComponent.label.unit',
    'ListComponent.label.unitAll',
    'SearchConditionComponent.label.title',
    'SearchConditionComponent.label.currentCondition',
    'SearchConditionComponent.label.notSet',
    'SearchConditionComponent.button.search',
    'SearchConditionComponent.button.clear',
    'au.COMPONENTS.validate.input',
    'au.COMPONENTS.validate.required',
    'au.COMPONENTS.validate.duplicated',
    'ColumnComponent.error.required',
    'TitleComponent.label.required',
    'RadioComponent.label.notSet',
    'FormReadonlyComponent.label.notEntered',
    'FormReadonlyComponent.label.unselected',
    'UnitComponent.label.note1',
    'UnitComponent.label.note2',
    'UnitComponent.modal.title.addition',
    'UnitComponent.modal.title.edit',
    'UnitComponent.modal.button.cancel',
    'UnitComponent.modal.button.regist',
    'UnitComponent.contextmenu.addition',
    'UnitComponent.contextmenu.edit',
    'UnitComponent.contextmenu.disabled',
    'UnitComponent.contextmenu.enabled',
    'UnitComponent.contextmenu.remove',
    'AccessUnitComponent.label.pleaseSelect',
    'AccessUnitComponent.label.note',
    'AccessUnitComponent.modal.title',
    'AccessUnitComponent.modal.th.role',
    'AccessUnitComponent.modal.th.period',
    'AccessUnitComponent.modal.checkbox.period',
    'AccessUnitComponent.modal.delete',
    'AccessUnitComponent.modal.error.role',
    'AccessUnitComponent.modal.error.period',
    'AccessUnitComponent.modal.button.cancel',
    'AccessUnitComponent.modal.button.ok',
    'AccessUnitComponent.contextmenu.role',
    'AccessUnitComponent.contextmenu.default',
    'AccessUnitComponent.contextmenu.check',
    'AccessUnitComponent.contextmenu.uncheck',
    'au.COMPONENT.AccessUnitComponent.label.units',
    'au.COMPONENTS.label.tree.more',
    'Please.select.tenant',
    'Search...',
    'Please.select.language',
    'Save.default.language',
    'CurrentUnitComponent.current',
    'CurrentUnitComponent.includeLower',
    'SelectLanguageComponent.setlanguage',
    'SelectLanguageComponent.selectlanguage',
    'SelectLanguageComponent.setdefault',
    'MemberSearchComponent.searchConditionSetting',
    'MemberSearchComponent.button.searchExecution',
    'MemberSearchComponent.button.saveSearchCondition1',
    'MemberSearchComponent.button.saveSearchCondition2',
    'MemberSearchComponent.button.clearSearchCondition',
    'MemberSearchComponent.savedSearchCondition',
    'MemberSearchComponent.savedSearchCondition.noSearchCondition',
    'MemberSearchComponent.savedSearchCondition.edit',
    'MemberSearchComponent.savedSearchCondition.enable',
    'MemberSearchComponent.savedSearchCondition.disable',
    'MemberSearchComponent.label.searchCondition',
    'MemberSearchComponent.label.operator.and',
    'MemberSearchComponent.label.operator.or',
    'MemberSearchComponent.searchCondition',
    'MemberSearchComponent.searchCondition.noResult',
    'MemberSearchComponent.button.sendMessage',
    'MemberSearchComponent.button.saveSegmentSet',
    'MemberSearchComponent.button.saveCondition',
    'MemberSearchComponent.button.saveTriggerCondition',
    'MemberSearchComponent.modal.saveSegmentSet',
    'MemberSearchComponent.modal.saveSegment.name',
    'MemberSearchComponent.modal.saveSegment.placeholder',
    'MemberSearchComponent.modal.saveSegment.validate',
    'MemberSearchComponent.modal.saveSegmentSet.new',
    'MemberSearchComponent.modal.saveSegmentSet.new.placeholder',
    'MemberSearchComponent.modal.saveSegmentSet.new.validate',
    'MemberSearchComponent.modal.saveSegmentSet.add',
    'MemberSearchComponent.modal.saveSegmentSet.add.noSegmentSet',
    'MemberSearchComponent.modal.saveSegmentSet.add.validate',
    'MemberSearchComponent.modal.saveSegmentSet.noSearchCondition',
    'MemberSearchComponent.modal.saveCondition',
    'MemberSearchComponent.modal.saveCondition.name',
    'MemberSearchComponent.modal.saveCondition.name.placeholder',
    'MemberSearchComponent.modal.saveCondition.name.validate',
    'MemberSearchComponent.modal.saveCondition.noSearchCondition',
    'MemberSearchComponent.modal.saveTriggerCondition',
    'MemberSearchComponent.modal.saveTriggerCondition.note',
    'MemberSearchComponent.modal.saveTriggerCondition.name',
    'MemberSearchComponent.modal.saveTriggerCondition.name.placeholder',
    'MemberSearchComponent.modal.saveTriggerCondition.name.validate',
    'MemberSearchComponent.modal.saveTriggerCondition.noSearchCondition',
    'MemberSearchComponent.order',
    'MemberSearchComponent.event',
    'MemberSearchComponent.unit',
    'MemberSearchComponent.workflow',
    'MemberSearchComponent.campaign',
    'MemberSearchComponent.registry',
    'MemberSearchComponent.member_attribute',
    'MemberSearchComponent.royalty',
    'MemberSearchComponent.member_list',
    'MemberSearchComponent.segment_set',
    'MemberSearchComponent.search_condition',
    'MemberSearchComponent.order.item_category',
    'MemberSearchComponent.order.item_name',
    'MemberSearchComponent.order.purchase',
    'MemberSearchComponent.order.purchase.purchase',
    'MemberSearchComponent.order.purchase.purchase.shipped',
    'MemberSearchComponent.order.purchase.purchase.unshipped',
    'MemberSearchComponent.order.purchase.noPurchase',
    'MemberSearchComponent.order.purchase.noPurchase.putIn',
    'MemberSearchComponent.order.purchase.noPurchase.notPutIn',
    'MemberSearchComponent.order.purchase.invalid',
    'MemberSearchComponent.order.count',
    'MemberSearchComponent.order.price',
    'MemberSearchComponent.event.id',
    'MemberSearchComponent.event.session_id',
    'MemberSearchComponent.event.behavior',
    'MemberSearchComponent.event.start',
    'MemberSearchComponent.event.end',
    'MemberSearchComponent.unit.selectUnit',
    'MemberSearchComponent.unit.target',
    'MemberSearchComponent.unit.target.attribution',
    'MemberSearchComponent.unit.target.otherThanAttribution',
    'MemberSearchComponent.unit.target.invalid',
    'MemberSearchComponent.workflow.workflow_name',
    'MemberSearchComponent.workflow.state',
    'MemberSearchComponent.workflow.event',
    'MemberSearchComponent.campaign.id',
    'MemberSearchComponent.campaign.segment_id',
    'MemberSearchComponent.campaign.conversion',
    'MemberSearchComponent.campaign.conversion.present',
    'MemberSearchComponent.campaign.conversion.absent',
    'MemberSearchComponent.campaign.conversion.noAction',
    'MemberSearchComponent.registry.kind',
    'MemberSearchComponent.registry.id',
    'MemberSearchComponent.registry.behavior',
    'MemberSearchComponent.member_attribute.form_type',
    'MemberSearchComponent.member_attribute.attribute',
    'MemberSearchComponent.member_attribute.attribute_type',
    'MemberSearchComponent.member_attribute.form_id',
    'MemberSearchComponent.member_attribute.value',
    'MemberSearchComponent.royalty.stage_id',
    'MemberSearchComponent.royalty.point',
    'MemberSearchComponent.segment_set.segment_set_id',
    'MemberSearchComponent.segment_set.segment_id',
    'MemberSearchComponent.segment_set.contents',
    'MemberSearchComponent.search_condition.id',
    'MemberSearchComponent.search_condition.contents',
    'MemberSearchComponent.selectAll',
    'MemberSearchComponent.pleaseSelect',
    'MemberSearchComponent.period',
    'MemberSearchComponent.start_date',
    'MemberSearchComponent.end_date',
    'MemberSearchComponent.validity',
    'MemberSearchComponent.count',
    'MemberSearchComponent.more',
    'MemberSearchComponent.lessthan',
    'MemberSearchComponent.elapsed_date',
    'MemberSearchComponent.passage',
    'au.COMPONENT.FileComponent.label.message',
    'au.COMPONENT.FileComponent.label.invalidFileType',
    'au.COMPONENT.FileComponent.label.removeFile',
    'au.COMPONENT.FileComponent.radio.auto',
    'au.COMPONENT.FileComponent.radio.manual',
    'NaviComponent.back',
    'CampaignSegmentComponent.label.total',
    'CampaignSegmentComponent.label.people',
    'CampaignSegmentComponent.label.percent',
    'CampaignSegmentComponent.label.uncounted',
    'CampaignSegmentComponent.label.selectSegmentset',
    'CampaignSegmentComponent.label.copy',
    'CampaignSegmentComponent.label.segmentset',
    'CampaignSegmentComponent.label.note',
    'CampaignSegmentComponent.label.note.readonly',
    'CampaignSegmentComponent.label.segment',
    'CampaignSegmentComponent.label.fragment',
    'CampaignSegmentComponent.label.selectFragment',
    'CampaignSegmentComponent.label.addFragment',
    'CampaignSegmentComponent.label.addSegment',
    'CampaignSegmentComponent.error.segment',
    'CampaignSegmentComponent.error.fragment',
    'CampaignSegmentComponent.error.unique',
    'CampaignSegmentComponent.error.multiple',
    'CampaignSegmentComponent.error.range',
    'CampaignMeasureComponent.radio.unselected',
    'CampaignMeasureComponent.select2.placeholder',
    'CampaignContentsComponent.media.email',
    'CampaignContentsComponent.media.webmessage',
    'CampaignContentsComponent.media.push',
    'CampaignContentsComponent.media.sms',
    'CampaignContentsComponent.label.selectCampaign',
    'CampaignContentsComponent.label.copy',
    'CampaignContentsComponent.label.title',
    'CampaignContentsComponent.label.summary',
    'CampaignContentsComponent.label.contents',
    'CampaignContentsComponent.label.insertTag',
    'CampaignContentsComponent.label.campaignTag',
    'CampaignContentsComponent.label.setCommonText',
    'CampaignContentsComponent.label.deleteCommonText',
    'CampaignTimingComponent.campaign.placeholder',
    'CampaignTimingComponent.campaign.measure',
    'CampaignTimingComponent.campaign.behavior',
    'CampaignTimingComponent.campaign.behaviorAct',
    'CampaignTimingComponent.campaign.withinDate',
    'CampaignTimingComponent.campaign.withinDate.label1',
    'CampaignTimingComponent.campaign.withinDate.label2',
    'CampaignTimingComponent.campaign.elapsedDate',
    'CampaignTimingComponent.campaign.elapsedDate.label1',
    'CampaignTimingComponent.campaign.elapsedDate.label2',
    'CampaignTimingComponent.trigger.placeholder',
    'CampaignConfirmComponent.button.send',
    'CampaignConfirmComponent.campaign.withinDate.label1',
    'CampaignConfirmComponent.campaign.withinDate.label2',
    'CampaignConfirmComponent.campaign.elapsedDate.label1',
    'CampaignConfirmComponent.campaign.elapsedDate.label2',
    'CampaignConfirmComponent.label.timing',
    'CampaignConfirmComponent.label.target',
    'CampaignConfirmComponent.label.targetPercent',
    'CampaignConfirmComponent.label.targetValue',
    'CampaignConfirmComponent.label.segment',
    'CampaignConfirmComponent.label.estimate',
    'Component.label.selectLanguage',
    'Component.label.html',
    'Component.label.text',
    'Component.modal.selectLanguage',
    'Component.modal.unselected',
    'Component.modal.button.cancel',
    'Component.modal.button.ok',
    'Component.specifydate.placeholder',
    'ScopeComponent.label.title',
    'ScopeComponent.checkbox.unchecked',
    'ScopeComponent.checkbox.checked',
    'ScopeComponent.label.currentunit',
    'ScopeComponent.label.units',
    'ItemSubItemComponent.label.item_set',
    'ItemSubItemComponent.label.item_no',
    'ItemSubItemComponent.label.item_name',
    'ItemSubItemComponent.label.item_standard_price',
    'ItemSubItemComponent.label.item_price',
    'ItemSubItemComponent.label.item_diff_price',
    'ItemSubItemComponent.label.item_num',
    'ItemSubItemComponent.label.item_subtotal',
    'ItemSubItemComponent.label.item_total',
    'ItemSubItemComponent.error.price',
    'ItemModalComponent.label.search',
    'ItemModalComponent.item.base',
    'ItemModalComponent.item.item_id',
    'ItemModalComponent.item.item_type',
    'ItemModalComponent.item.item_name',
    'ItemModalComponent.item.item_no',
    'ItemModalComponent.item.price',
    'ItemModalComponent.item.category',
    'ItemModalComponent.item.item_category',
    'ItemModalComponent.button.complete',
    'ItemModalComponent.button.cancel',
    'TextOperatorComponent.select.eq',
    'TextOperatorComponent.select.like',
    'TextOperatorComponent.select.prefix',
    'TextOperatorComponent.select.suffix',
    'RangeOperatorComponent.radio.match',
    'RangeOperatorComponent.radio.range',
    'RangeOperatorComponent.select.number.ge',
    'RangeOperatorComponent.select.number.gt',
    'RangeOperatorComponent.select.number.le',
    'RangeOperatorComponent.select.number.lt',
    'RangeOperatorComponent.select.datetime.ge',
    'RangeOperatorComponent.select.datetime.gt',
    'RangeOperatorComponent.select.datetime.le',
    'RangeOperatorComponent.select.datetime.lt',
    'DisplayTargetComponent.checkbox.nonMember',
    'DisplayTargetComponent.checkbox.member',
    'AuComponent.passwordChange.link',
    'ItemCategoryTreeComponent.label.note1',
    'ItemCategoryTreeComponent.label.openAll',
    'ItemCategoryTreeComponent.label.closeAll',
    'TopComponent.navi.title',
    'TopComponent.label.nodata',
    'SortComponent.label.note',
    'SortTreeComponent.label.note',
    'SortTreeComponent.label.openAll',
    'SortTreeComponent.label.closeAll',
    'TabGroupComponent.error.input',
    'ItemPeriodComponent.label.startDate',
    'ItemPeriodComponent.label.endDate',
    'ItemPriceComponent.label.startDate',
    'ItemPriceComponent.label.price',
    'ItemImageComponent.label.image',
    'ItemImageComponent.label.alt',
    'ItemImageComponent.label.dispFlg',
    'CsvComponent.button.download',
    'InquiryComponent.label.openAll',
    'InquiryComponent.label.closeAll',
    'InquiryComponent.button.quote',
    'RegistryCondComponent.label.is_available',
    'RegistryCondComponent.label.start_date',
    'RegistryCondComponent.label.end_date',
    'RegistryCondComponent.label.capacity_public',
    'RegistryCondComponent.label.capacity_label',
    'RegistryCondComponent.label.capacity',
    'RegistryCondComponent.label.is_limited',
    'RegistryCondComponent.label.times_label',
    'RegistryPointComponent.label.point',
    'RegistryPointComponent.label.common',
    'RegistryPointComponent.label.stage',
    'MailDeliveryConponent.item.is_sendable',
    'MailDeliveryConponent.item.send_type',
    'MailDeliveryConponent.item.send_datetime',
    'MailDeliveryConponent.item.test_address',
    'MailDeliveryConponent.item.sender_email_id',
    'MailDeliveryConponent.item.replay_email_id',
    'MailDeliveryConponent.item.segment_id',
    'MailDeliveryConponent.item.sentData',
    'MailDeliveryConponent.item.copy',
    'MailDeliveryConponent.item.sentDataSelect',
    'MailDeliveryConponent.item.copy',
    'MailDeliveryConponent.item.title',
    'MailDeliveryConponent.item.contents',
    'MailDeliveryConponent.item.contentsLabel',
    'MailDeliveryConponent.item.timing',
    'MailDeliveryConponent.item.send_include_lower',
    'au.COMPONENT.QuestionnaireComponent.select.select_question_type',
    'au.COMPONENT.QuestionnaireComponent.select.select_page_parts',
    'au.COMPONENT.QuestionnaireComponent.select.copy_question',
    'au.COMPONENT.QuestionnaireComponent.error.question_is_not_set',
    'au.COMPONENT.QuestionnaireComponent.error.question_type_is_not_set',
    'au.COMPONENT.QuestionnaireComponent.label.question_setting',
    'au.COMPONENT.QuestionnaireComponent.label.image_path',
    'au.COMPONENT.QuestionnaireComponent.label.title',
    'au.COMPONENT.QuestionnaireComponent.label.name',
    'au.COMPONENT.QuestionnaireComponent.label.description',
    'au.COMPONENT.QuestionnaireComponent.label.max_length',
    'au.COMPONENT.QuestionnaireComponent.label.pa_type_name',
    'au.COMPONENT.QuestionnaireComponent.label.is_required',
    'au.COMPONENT.QuestionnaireElementComponent.label.options',
    'au.COMPONENT.QuestionnaireElementComponent.label.is_other_field',
    'au.COMPONENT.QuestionnaireElementComponent.label.add_other',
    'au.COMPONENT.TemplateComponent.label.editTag',
    'au.COMPONENT.TemplateValueComponent.label.template_id',
    'au.COMPONENT.TemplateValueComponent.label.values',
    'au.COMPONENT.TemplateValueComponent.label.bg_color',
    'au.COMPONENT.TemplateValueComponent.label.color',
    'au.COMPONENT.TemplateValueComponent.label.templateNote',
    'au.COMPONENT.TemplateValueComponent.label.noEditTag',
    'au.COMPONENTS.button.preview',
    'au.COMPONENTS.modal.button.close',
    'au.COMPONENT.ColorComponent.label.choose',
    'au.COMPONENT.ColorComponent.label.cancel',
    'au.COMPONENT.BulkComponent.button.bulkUpdate',
    'au.COMPONENT.BulkComponent.button.bulkDelete',
    'au.COMPONENT.BulkComponent.label.errorInfo',
    'au.COMPONENT.BulkComponent.label.bulkUpdateTitle',
    'au.COMPONENT.BulkComponent.label.confirmUpdate',
    'au.COMPONENT.BulkComponent.label.confirmDelete',
    'au.COMPONENT.BulkComponent.label.bulkDone',
    'au.COMPONENT.AddRowComponent.error.duplicated',
    'au.COMPONENT.FormCopyComponent.label.copy',
];
//# sourceMappingURL=message.service.js.map